import Vue from 'vue'

import AExt from '@/components/AExt.vue'
import AInt from '@/components/AInt.vue'
import SmooBtn from '@/components/SmooBtn.vue'
import SmooCard from '@/components/SmooCard.vue'
import SmooRoleIcon from '@/components/SmooRoleIcon.vue'

Vue.component('AExt', AExt)
Vue.component('AInt', AInt)
Vue.component('SmooBtn', SmooBtn)
Vue.component('SmooCard', SmooCard)
Vue.component('SmooRoleIcon', SmooRoleIcon)
